import type {
  ErrorResponse,
  SugarmateError,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { isAxiosError } from "axios"

export function getSugarmateError(e: unknown): SugarmateError | undefined {
  if (isAxiosError(e) && e.response) {
    if (e.response.data) {
      const data = e.response.data as ErrorResponse
      return data.error
    }

    // if the response body is empty, mock a sugarmate error response
    return {
      status: e.response.status,
      code: null,
      title: "",
      detail: "",
    }
  }

  return undefined
}
